import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4f809fa6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "Ning-before-detail"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  key: 0,
  class: "list"
};
var _hoisted_4 = {
  class: "left"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  key: 1,
  class: "list"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "list-box"
  }, "未选择人", -1);
});

var _hoisted_8 = [_hoisted_7];
var _hoisted_9 = {
  key: 2,
  class: "page"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Ning-handle"
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "年度考核",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Data.title), 1), _ctx.Data.list.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.list, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "list-box"
    }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.userName || "无"), 1), _createElementVNode("div", {
      class: _normalizeClass(["right", {
        rightC: item.state == 4,
        rightB: item.state == 2 || item.state == 3
      }]),
      onClick: function onClick($event) {
        return _ctx.itemClick(item);
      }
    }, _toDisplayString(_ctx.Data.options[item.state].name), 11, _hoisted_5)]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)), _ctx.Data.list.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_Pagination, {
    pagesize: 10,
    "total-num": _ctx.Data.total,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])])) : _createCommentVNode("", true)]), _hoisted_10], 64);
}